// extracted by mini-css-extract-plugin
export default {"h1":"Htag_h1__M+xDH","h2":"Htag_h2__74K7J","h3":"Htag_h3__x9j4h","blueColor":"Htag_blueColor__C8dkl","wrapper":"Htag_wrapper__Dqr+v"};